import { Injectable } from '@angular/core';
import  _  from 'underscore'; 

@Injectable({
  providedIn: 'root'
})
export class HelperService {


  constructor() { }

  public RemoveItemFromArray(array: any, item: any, predicate: any) {
    var itemToRemove = this.Find(array, predicate);
    if (itemToRemove) {
      let returnedArray = _.without(array, itemToRemove);
      return returnedArray;
    }
    return array;
  }

  public AddItemToArray(array: any, item: any) {
    let returnedArray = _.union(array, item);
    return returnedArray;
  }

  public Exists(array: any, predicate: any): boolean {
    return _.findIndex(array, predicate)>=0;
  }

  public Find(array: any, predicate: any): any {
    return _.find(array, predicate);
  }


  Without<T>(list: T[], predicate: any): T[] {
   return _.reject(list, predicate);
  }

}
